const Drizzle = (props) => (
  <svg
    width="38"
    height="48"
    viewBox="0 0 38 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.0625 22.0239C13.0625 20.0276 13.6545 18.0761 14.7636 16.4161C15.8727 14.7562 17.4491 13.4625 19.2935 12.6985C21.1379 11.9345 23.1674 11.7347 25.1254 12.1241C27.0834 12.5136 28.882 13.4749 30.2936 14.8866C31.7052 16.2982 32.6666 18.0967 33.056 20.0547C33.4455 22.0127 33.2456 24.0422 32.4816 25.8866C31.7177 27.731 30.4239 29.3075 28.764 30.4166C27.1041 31.5257 25.1526 32.1177 23.1562 32.1177H11.2812C10.3329 32.1169 9.39616 31.9096 8.53605 31.5102C7.67595 31.1108 6.91313 30.5289 6.30062 29.805C5.6881 29.081 5.24059 28.2324 4.98918 27.318C4.73776 26.4036 4.68848 25.4454 4.84476 24.5101C5.00104 23.5748 5.35913 22.6847 5.89413 21.9017C6.42914 21.1187 7.12824 20.4616 7.94283 19.9761C8.75743 19.4906 9.66798 19.1883 10.6112 19.0902C11.5544 18.9921 12.5077 19.1006 13.4048 19.4082"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 40.375L19 39.1875"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 46.3125L19 45.125"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.875 38L11.875 36.8125"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.875 43.9375L11.875 42.75"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.125 43.9375L26.125 42.75"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.8251 8.47615L11.2065 4.96777"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.22676 11.4042L4.30853 9.36084"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.04588 16.7266L2.53751 17.3452"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.1472 9.65675L19.1906 6.73853"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.66589 20.1467C6.9974 19.3718 6.50365 18.462 6.21825 17.4792C5.93285 16.4964 5.86249 15.4636 6.01196 14.4512C6.16142 13.4387 6.52721 12.4703 7.08443 11.6119C7.64165 10.7535 8.37723 10.0252 9.24114 9.47647C10.105 8.92778 11.077 8.5716 12.0909 8.43217C13.1047 8.29274 14.1368 8.37332 15.1167 8.66845C16.0966 8.96357 17.0015 9.4663 17.7698 10.1424C18.538 10.8186 19.1517 11.6523 19.5689 12.5868"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default Drizzle
